import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ThemeContext from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { PriceProvider } from "./context/SocketContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <AuthProvider>
        <ThemeContext>
          <PriceProvider>
            <App />
          </PriceProvider>
        </ThemeContext>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
